import { useEffect, useState } from "react";
import api from "../config/api";

const useHomeData = (lat, lng, city) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHome = async () => {
      try {
        setLoading(true);
        // Build query params
        const params = {};
        if (lat) params.lat = lat;
        if (lng) params.lng = lng;
        if (city) params.city = city;

        const res = await api.get("/home", { params });
        setData(res.data);
      } catch (err) {
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchHome();
  }, [lat, lng, city]);

  return { data, loading, error };
};

export default useHomeData;